import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from 'material-ui/styles';
import Layout from '../../components/main/layout/layout';
import styles from './styles';

function isApplicationRedirect() {
	return window.location.search.substr(1).includes('app=true');
}

const PrivacyPolicy = props => {
	const {classes, history} = props;
	const isRedirect = isApplicationRedirect();

	return (
		<Layout
			title={<div>PRIVACY & COOKIES POLICY</div>}
			hideHeaderControls={isRedirect}
			handleGoBack={() => {
				if (history.length <= 2) {
					history.push('/');
				} else {
					history.goBack();
				}
			}}
			isHomepage={false}
		>
			<div className={classes.container}>
				<h1>JUVORA&#8482; Guide App PRIVACY & COOKIES POLICY</h1>
				Juvora Limited is committed to protecting and respecting your privacy.
				<h3>Scope of Policy</h3>
				This policy and the JUVORA&#8482; Guide App Terms of Use apply to your use of:
				<ul>
					<li>JUVORA&#8482; Guide app mobile application software, the data supplied with the
				software, (JUVORA&#8482; Guide App) and any updates or supplements to it.
					</li>
					<li>The related online electronic documentation (Documentation).</li>
					<li>The service you connect to via the JUVORA&#8482; Guide App and the content we provide
				to you through it (Service).
					</li>
				</ul>
				<p>This policy sets out the basis on which any personal data we collect from you, or that you
				provide to us, will be processed by us. Please read the following carefully to understand
				our views and practices regarding your personal data and how we will treat it.
				</p>
				For the purpose of the Data Protection Act 1998, the data controller is:
				<ul>
					<li>Juvora Limited (Juvora or We or Us)</li>
					<li>Registered in England and Wales</li>
					<li>Company number 8149439</li>
					<li>Registered office is at Victrex Technology Centre, Hillhouse International, Thornton
				Cleveleys, Lancashire FY5 4QD.
					</li>
				</ul>
				<h3>Information we collect from you</h3>
				We will collect and process the following data about you:
				<ul>
					<li>Information you give us (Submitted information): This is information you give us
				about you by filling in forms on the JUVORA&#8482; Guide App, or by corresponding with
				us (for example, by e-mail or chat). It includes information you provide when you
				register to use the JUVORA&#8482; Guide App, download or register the JUVORA&#8482; Guide
				App or search for Documentation, and when you report a problem with the
				JUVORA&#8482; Guide App, our Services, or the Documentation. If you contact us, we will
				keep a record of that correspondence. The information you give us will only include
				your name and e-mail address.
					</li>
				</ul>
				<h3>Information we collect about you and your device</h3>
				<p>Information we collect automatically: When you use the JUVORA&#8482; Guide App, we may
				collect anonymous information about your visit and your usage of the JUVORA&#8482; Guide
				App. That information may include your IP address, your operating system, and
				information about how you interacted with the JUVORA&#8482; Guide App. We may collect this
				information as a part of log files as well as through the use of cookies or other tracking
				technologies.
				</p>
				<h3>Cookies</h3>
				<p>We use cookies to distinguish you from other users of the JUVORA&#8482; Guide App, the
				Services or the mobile application store. This helps us to provide you with a good
				experience when you use the JUVORA&#8482; Guide App or browse any of the sites and also
				allows us to improve the JUVORA&#8482; Guide App. For detailed information on the cookies
				we use and the purposes for which we use them, see our cookie policy <a target="_blank" rel="noopener noreferrer" href="https://juvoradental.com/en/cookie-policy">https://juvoradental.com/en/cookie-policy</a>.
				</p>
				<h3>Uses made of the information</h3>
				<p>We use the information to provide, support, and improve the Services and educational
				content that we offer.
				</p>
				<p>We do not disclose any information we collect to any third party.</p>
				<h3>Where we store your personal data</h3>
				<p>The data that we collect from you will be transferred to, and stored at, a destination
				outside the European Economic Area (EEA). It will also be processed by staff operating
				outside the EEA who work for us or for one of our suppliers. By submitting your personal
				data, you agree to this transfer, storing or processing. We will take all steps reasonably
				necessary to ensure that your data is treated securely and in accordance with this privacy
				policy.
				</p>
				<p>All information you provide to us is stored on our secure servers. Unfortunately, the
				transmission of information via the internet is not completely secure. Although we will
				do our best to protect your personal data, we cannot guarantee the security of your data
				transmitted to the JUVORA&#8482; Guide App; any transmission is at your own risk. Once we
				have received your information, we will use strict procedures and security features to try
				to prevent unauthorised access.
				</p>
				<h3>Your rights</h3>
				<p>You have the right to ask us not to process your personal data for marketing purposes.
				We will usually inform you (before collecting your data) if we intend to use your data for
				such purposes or if we intend to disclose your information to any third party for such
				purposes. You can exercise your right to prevent such processing by checking certain
				boxes on the forms we use to collect your data. You can also exercise the right at any
				time by contacting us at <a href="mailto:appenquiry@juvoradental.com">appenquiry@juvoradental.com</a>.
				</p>
				<p>The JUVORA&#8482; Guide App may, from time to time, contain links to and from the websites
				of our partner networks, advertisers and affiliates (including, but not limited to, websites
				on which JUVORA&#8482; Guide App or the Services are advertised). If you follow a link to any
				of these websites, please note that these websites and any services that may be
				accessible through them have their own privacy policies and that we do not accept any
				responsibility or liability for these policies or for any personal data that may be collected
				through these websites or services, such as contact and location data. Please check these
				policies before you submit any personal data to these websites or use these services.
				</p>
				<h3>Access to Information</h3>
				<p>The Data Protection Act 1998 gives you the right to access information held about you.
				Your right of access can be exercised in accordance with that Act. Any access request will
				be subject to a small fee of £10 to contribute towards our costs in providing you with
				details of the information we hold about you.
				</p>
				<h3>Changes to Privacy Policy</h3>
				<p>Any changes we may make to our privacy policy in the future will be posted on this page
				and, where appropriate, notified to you by e-mail or when you next start the JUVORA&#8482;
				Guide App. The new terms may be displayed on-screen and you may be required to read
				and accept them to continue your use of the JUVORA&#8482; Guide App or the Services.
				</p>
				<h3>Contact</h3>
				<p>Questions, comments and requests regarding this Privacy Policy are welcomed and
				should be addressed to <a href="mailto:appenquiry@juvoradental.com">appenquiry@juvoradental.com</a>.
				</p>
			</div>
		</Layout>
	);
};

PrivacyPolicy.propTypes = {
	classes: PropTypes.object.isRequired,
	history: PropTypes.object.isRequired
};

export default withStyles(styles)(PrivacyPolicy);



// WEBPACK FOOTER //
// ./src/client/pages/terms/privacy-policy.jsx